/* eslint-disable no-unused-vars */
import { TabContext, TabList } from '@mui/lab'
import { Box, IconButton, SwipeableDrawer, Tab, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { IoAdd } from 'react-icons/io5'
import { LiaSave } from 'react-icons/lia'
import { RxCross2 } from 'react-icons/rx'
import { Button } from 'src/Common/ui/button'
import CustomSearchField from 'src/Common/ui/searchInput'
import { cn, featValid, inputValidation } from 'src/lib/utils'
import ExecutiveRolesPermissionsTable from 'src/Components/Settings/UserManagement/ExecutiveRolesPermissionsTable'
import RiskRolsAndPermissionsTable from 'src/Components/Settings/UserManagement/RiskRolsAndPermissionsTable'
import ComplianceRolesPermissionsTable from 'src/Components/Settings/UserManagement/ComplianceRolesPermissionsTable'
import { Checkbox } from 'src/Common/ui/checkbox'
import { RadioGroup, RadioGroupItem } from 'src/Common/ui/radio-group'
import Input from 'src/Common/ui/input'
import { useForm } from 'react-hook-form'
import ToggleSwitch from 'src/Common/ui/ToggleSwitch'
import DatePickerInput from 'src/Common/ui/DatePickerInput'
import { useSettingsStore } from '../Store/Store'
import { useLocation, useNavigate } from 'react-router'
import { toast } from 'react-toastify'
import { CREATE_USER_MANAGEMENT, UPDATE_USER_MANAGEMENT } from 'src/Entities/Features'
import { ROLE_CHECK, ROLE_COMPLIANCE, ROLE_EXECUTIVE, ROLE_RISK, ROLE_UNCHECK } from 'src/Entities/RolePermissionEntities'
import { toaster } from 'src/Common/ui/Toaster'
import { IoIosCloseCircleOutline } from 'react-icons/io'

const RolesAnaPermissionsContainer = () => {
    const { control, register, reset, formState: { errors, isSubmitting, isLoading }, handleSubmit, setValue } = useForm({
        mode: 'onChange',
        defaultValues: {}
    })
    const location = useLocation()

    const queryParams = new URLSearchParams(location.search)
    const [ activeInActiveTabChange, setActiveInActiveTabChange ] = useState('1')
    const [ rolesAndPermissionSearch, setRolesAndPermissionSearch ] = useState('')
    const [ addState, setAddState ] = useState({ drawerType: '', right: false })
    const [ accordianOpen, setAccordianOpen ] = useState({ executive: true, risk: true, compliance: true })
    const { getAllRolesAccessData, getAllRolesAccess, createRoles, createRolePermissions, roleIdClear, getRoleByIdData, getRoleById, getAllUsersListLoading } = useSettingsStore()
    const [ wholeData, setWholeData ] = useState([])
    const [ riskRoles, setRiskRoles ] = useState([])
    const [ complianceRoles, setComplianceRoles ] = useState([])
    const [ executiveRoles, setExecutiveRoles ] = useState([])
    const [ compRsData, setCompRsData ] = useState([])
    const [ execRsData, setExecRsData ] = useState([])
    const [ riskRsData, setRiskRsData ] = useState([])
    const roleStatus = queryParams.get('roleStatus')
    const orgId = localStorage.getItem('orgId')
    const [ dataCount, setDataCount ] = useState({
        active: 0,
        inActive: 0
    })
    const [ addRoleData, setAddRoleData ] = useState({
        organizationId: orgId,
        roleGroups: [
            {
                id: 0,
                roleGroup: 1,
                status: 2
            },
            {
                id: 0,
                roleGroup: 3,
                status: 2
            },
            {
                id: 0,
                roleGroup: 2,
                status: 2
            }
        ],
        type: true,
        roleName: '',
        expiryDate: null,
        isActive: true
    })
    const navigate = useNavigate()
    const handleTabChange = (event, newValue) => {
        setActiveInActiveTabChange(newValue)
        queryParams.set('roleStatus', newValue)
        navigate(`?${queryParams.toString()}`)
    }
    const [ submitType, setSubmitType ] = useState('added')
    const toggleDrawer = (anchor, open, type, data = null) => (event) => {
        setAddState({ ...addState, [anchor]: open, drawerType: type })
        if (data) {
            getRoleById(data)
            setSubmitType('updated')
        } else {
            roleIdClear()
            setSubmitType('added')
            setAddRoleData({
                organizationId: orgId,
                roleGroups: [
                    {
                        id: 0,
                        roleGroup: 1,
                        status: 2
                    },
                    {
                        id: 0,
                        roleGroup: 3,
                        status: 2
                    },
                    {
                        id: 0,
                        roleGroup: 2,
                        status: 2
                    }
                ],
                type: true,
                roleName: '',
                expiryDate: null,
                isActive: true
            })
        }
    }
    useEffect(() => {
        if (getRoleByIdData?.length > 0) {
            const arr = []
            for (let i = 1; i <= 3; i++) {
                const find = getRoleByIdData[0]?.roleGroups?.find(ele => ele.roleGroup === i)
                if (find) {
                    arr.push(find)
                } else {
                    arr.push({
                        id: 0,
                        roleGroup: i,
                        status: ROLE_UNCHECK
                    })
                }
            }
            const data = getRoleByIdData[0]
            data.roleName = data.name
            data.roleGroups = arr
            setAddRoleData(JSON.parse(JSON.stringify(data)))
            setValue('roleName', data.roleName)
        }
    }, [getRoleByIdData])
    const onSubmit = () => {
        const finalData = addRoleData
        const roleData = addRoleData.roleGroups
        finalData.roleGroups = roleData.filter(ele => {
            if (ele.id !== 0) {
                return ele
            } else {
                if (ele.status !== +ROLE_UNCHECK) {
                    return ele
                }
            }
            return null
        }).filter((ele) => ele !== null)
        createRoles(finalData).then(() => {
            toaster('success', <p>{`Roles ${submitType} successfully`}</p>)
            setAddRoleData({
                organizationId: orgId,
                roleGroups: [
                    {
                        id: 0,
                        roleGroup: ROLE_EXECUTIVE,
                        status: ROLE_UNCHECK
                    },
                    {
                        id: 0,
                        roleGroup: ROLE_RISK,
                        status: ROLE_UNCHECK
                    },
                    {
                        id: 0,
                        roleGroup: ROLE_COMPLIANCE,
                        status: ROLE_UNCHECK
                    }
                ],
                type: true,
                roleName: '',
                expiryDate: null,
                isActive: true
            })
            getAllRolesAccess(orgId)
        })
        toggleDrawer('right', false, '')()
        reset()
    }
    const reStructure = async (data) => {
        const finaldata = []
        data.map(item => {
            Object.keys(item).map((ele) => {
                if (ele !== 'id' && ele !== 'name' && ele !== 'type' && ele !== 'expiryDate' && item[ele].status) {
                    finaldata.push({
                        roldId: item[ele].roleId,
                        featureId: item[ele].actionCombId
                    })
                }
                return ele
            })
            return item
        })
        return finaldata
    }
    const onFinalSubmit = async () => {
        let finaldata = []
        const r = await reStructure(riskRsData)
        const e = await reStructure(execRsData)
        const c = await reStructure(compRsData)
        finaldata = [ ...r, ...e, ...c ]
        createRolePermissions(finaldata).then(() => {
            toaster('success', <p>Roles updated successfully</p>)
            getAllRolesAccess(orgId)
        })
    }
    const handleCancel = () => {
        toggleDrawer('right', false, '')()
        reset()
        getAllRolesAccess(orgId)
    }

    const handleCancelClick = () => {
        getAllRolesAccess(orgId)
    }
    const handleChangeAddAndEditFormValue = (name, value) => {
        const data = addRoleData?.roleGroups?.map(ele => {
            if (+ele.roleGroup === +value) {
                ele.status = ele.status === ROLE_CHECK ? ROLE_UNCHECK : ROLE_CHECK
            }
            return ele
        })
        setAddRoleData({ ...addRoleData, roleGroups: data })
    }
    const handleActiveChange = (value) => {
        setAddRoleData({ ...addRoleData, isActive: value })
    }
    const handleChangeType = (value) => {
        setAddRoleData({ ...addRoleData, type: value })
    }
    const handleChange = (value) => {
        setAddRoleData({ ...addRoleData, roleName: value })
    }
    const handleDateChange = (value) => {
        setAddRoleData({ ...addRoleData, expiryDate: value })
    }
    useEffect(() => {
        getAllRolesAccess(orgId)
    }, [ roleStatus, location.pathname ])
    const features = JSON.parse(localStorage.getItem('features'))
    useEffect(() => {
        let data = []
        if (+roleStatus === 1) {
            data = getAllRolesAccessData?.active
        } else {
            data = getAllRolesAccessData?.inActive || []
        }
        setDataCount({
            active: getAllRolesAccessData?.active?.length || 0,
            inActive: getAllRolesAccessData?.inActive?.length || 0
        })
        setWholeData(data)
    }, [getAllRolesAccessData])
    useEffect(() => {
        let data = []
        if (+roleStatus === 1) {
            data = getAllRolesAccessData?.active
        } else {
            data = getAllRolesAccessData?.inActive || []
        }
        setWholeData(data?.filter((item) => item.role.toLowerCase().includes(rolesAndPermissionSearch?.toLowerCase())))
    }, [rolesAndPermissionSearch])
    useEffect(() => {
        const rr = []
        const cr = []
        const er = []
        wholeData?.map((item) => {
            if (+roleStatus === +item.roleStatus) {
                if (+item.kindId === ROLE_RISK) {
                    rr.push(item)
                }
                if (+item.kindId === ROLE_COMPLIANCE) {
                    cr.push(item)
                }
                if (+item.kindId === ROLE_EXECUTIVE) {
                    er.push(item)
                }
                item?.subActions?.map(ele => {
                    return ele
                })
            }
            return item
        })
        setRiskRoles(rr)
        setComplianceRoles(cr)
        setExecutiveRoles(er)
    }, [wholeData])
    return (
        <div className='w-[100%] h-[100%] p-[10px] bg-card flex flex-col '>
            <div>
                <TabContext value={activeInActiveTabChange}>
                    <Box sx={{ borderBottom: 2 }} className='text-primary-foreground'>
                        <TabList
                            onChange={handleTabChange}
                            sx={{
                                '& .MuiTabs-indicator': { background: 'hsl(var(--primary))' },
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Tab label="Active" value="1" className='!text-h4' sx={{ textTransform: 'none', '&.Mui-selected': { color: 'hsl(var(--muted))' } }} />
                            <div style={{ color: 'hsl(var(--primary))', backgroundColor: 'hsl(var(--primary-foreground))', borderRadius: '50%', fontSize: '12px', marginTop: '15px', marginLeft: '-12px', width: '20px', height: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                {dataCount.active}
                            </div>
                            <Tab label="In Active" value="2" className='!text-h4' sx={{ textTransform: 'none', '&.Mui-selected': { color: 'hsl(var(--muted))' } }} />
                            <div style={{ color: 'hsl(var(--primary))', backgroundColor: 'hsl(var(--primary-foreground))', borderRadius: '50%', fontSize: '12px', marginTop: '15px', marginLeft: '-12px', width: '20px', height: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                {dataCount.inActive}
                            </div>
                        </TabList>
                    </Box>
                    <Box className='py-[15px] flex flex-row justify-between items-center'>
                        <div>
                            <CustomSearchField
                                className="w-[100%] h-[100%] text-[#333]"
                                value={rolesAndPermissionSearch}
                                setSearch={setRolesAndPermissionSearch}
                                onValueChange={(e) => setRolesAndPermissionSearch(e)}
                            />
                        </div>
                        {featValid(features, CREATE_USER_MANAGEMENT) &&
                            <Tooltip title="Add Role" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                <div><IoAdd color='hsl(var(--primary))' style={{ marginRight: '30px', border: '1px solid hsl(var(--primary-thick-foreground))', cursor: 'pointer', borderRadius: '3px', height: '35px', width: '35px' }} onClick={toggleDrawer('right', true, 'Add Role')} /></div>
                            </Tooltip>}
                    </Box>
                </TabContext>
            </div>
            <div className='h-[73%] overflow-auto'>
                <div className=''>
                    <ExecutiveRolesPermissionsTable features={features} execRsData={execRsData} setExecRsData={setExecRsData} executiveRoles={executiveRoles} setExecutiveRoles={setExecutiveRoles} accordianOpen={accordianOpen} setAccordianOpen={setAccordianOpen} addState={addState} setAddState={setAddState} toggleDrawer={toggleDrawer} />
                </div>
                <div className='my-[50px]'>
                    <RiskRolsAndPermissionsTable features={features} riskRsData={riskRsData} setRiskRsData={setRiskRsData} riskRoles={riskRoles} setRiskRoles={setRiskRoles} accordianOpen={accordianOpen} setAccordianOpen={setAccordianOpen} addState={addState} setAddState={setAddState} toggleDrawer={toggleDrawer} />
                </div>
                <div className=''>
                    <ComplianceRolesPermissionsTable features={features} compRsData={compRsData} setCompRsData={setCompRsData} complianceRoles={complianceRoles} setComplianceRoles={setComplianceRoles} accordianOpen={accordianOpen} setAccordianOpen={setAccordianOpen} addState={addState} setAddState={setAddState} toggleDrawer={toggleDrawer} />
                </div>
            </div>
            {featValid(features, UPDATE_USER_MANAGEMENT) && <div className={cn('border-t-2 border-t-primary-foreground flex-grow py-8 bg-card flex flex-row items-center justify-end static pr-[20px] w-[100%]')}>
                <Button variant='outline' style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }} onClick={() => handleCancelClick()}>{'Cancel'}</Button>
                <Button className='ml-3' onClick={() => onFinalSubmit()} disabled={getAllUsersListLoading}>{'Save'}</Button>
            </div>}
            <SwipeableDrawer
                PaperProps={{ sx: { width: 500, overflowX: 'hidden', zIndex: 0 } }}
                className='z-auto'
                anchor={'right'}
                open={addState.right}
                onClose={handleCancel}
            >
                <div className='h-full w-full'>
                    <div className='h-[10%] w-full flex flex-row justify-between items-center border-b-2 pr-4'>
                        <p className="h-[100%] text-xl px-4 pt-[0px] font-bold flex flex-col justify-center" style={{ color: 'hsl(var(--primary))' }}>{addState?.drawerType}</p>
                        <Tooltip title="Close" placement="left" arrow componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <IconButton onClick={() => handleCancel()} aria-label="close">
                                <IoIosCloseCircleOutline className='text-[hsl(var(--primary))]' />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <div className='h-[80%] p-[20px] !overflow-auto w-full'>
                        <div>
                            <p>Role Group</p>
                            <div className='flex py-[15px] flex-row'>
                                <div className={cn(getRoleByIdData?.[0]?.roleGroups?.find((obj) => obj.roleGroup === ROLE_EXECUTIVE)?.status === 1 && 'pointer-events-none', 'mb-1.5 flex items-center')}>
                                    <Checkbox color={getRoleByIdData?.[0]?.roleGroups?.find((obj) => obj.roleGroup === ROLE_EXECUTIVE)?.status === 1 && 'hsl(var(--grey))'} name={'executive'} checked={addRoleData?.roleGroups?.find(ele => ele?.roleGroup === ROLE_EXECUTIVE)?.status === ROLE_CHECK} onCheckedChange={(e) => handleChangeAddAndEditFormValue('executive', 1)} />
                                    <label className='grc-label ml-2'>Executive</label>
                                </ div>
                                <div className={cn(getRoleByIdData?.[0]?.roleGroups?.find((obj) => obj.roleGroup === ROLE_RISK)?.status === 1 && 'pointer-events-none', 'px-[10px] mb-1.5 flex items-center')}>
                                    <Checkbox color={getRoleByIdData?.[0]?.roleGroups?.find((obj) => obj.roleGroup === ROLE_RISK)?.status === 1 && 'hsl(var(--grey))'} name={'risk'} checked={addRoleData?.roleGroups?.find(ele => ele?.roleGroup === ROLE_RISK)?.status === ROLE_CHECK} onCheckedChange={(e) => handleChangeAddAndEditFormValue('risk', 3)} />
                                    <label className='grc-label ml-2'>Risk</label>
                                </ div>
                                <div className={cn(getRoleByIdData?.[0]?.roleGroups?.find((obj) => obj.roleGroup === ROLE_COMPLIANCE)?.status === 1 && 'pointer-events-none', 'mb-1.5 flex items-center')}>
                                    <Checkbox color={getRoleByIdData?.[0]?.roleGroups?.find((obj) => obj.roleGroup === ROLE_COMPLIANCE)?.status === 1 && 'hsl(var(--grey))'} name={'compliance'} checked={addRoleData?.roleGroups?.find(ele => ele.roleGroup === ROLE_COMPLIANCE)?.status === ROLE_CHECK} onCheckedChange={(e) => handleChangeAddAndEditFormValue('compliance', 2)} />
                                    <label className='grc-label ml-2'>Compliance</label>
                                </ div>
                            </div>
                        </div>
                        <div>
                            <p>Type</p>
                            <RadioGroup className='flex py-[15px] space-x-6' defaultValue={addRoleData?.type} value={addRoleData?.type}
                                onValueChange={(e) => {
                                    const value = e
                                    handleChangeType(value)
                                }}>
                                <div className='flex items-center space-x-2'>
                                    <RadioGroupItem className='h-[20px] w-[20px]' value={true} />
                                    <label className='text-sm'>Permanent</label>
                                </div>
                                {/* feature not completed */}
                                {/* <div className='flex items-center space-x-2'>
                                    <RadioGroupItem className='h-[20px] w-[20px]' value={false} />
                                    <label className='text-sm'>Temporary</label>
                                </div> */}
                            </RadioGroup>
                        </div>
                        <div className='flex flex-row py-[20px]'>
                            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gap: 2 }}>
                                <Box sx={{ gridColumn: 'span 6' }}>
                                    <Box >
                                        <Input
                                            errors={errors}
                                            control={control}
                                            required
                                            rules={{
                                                validate: (value) => {
                                                    return inputValidation(value, value?.length < 25, 'This field is required', 'Characters should be less than 25')
                                                }
                                            }} name='roleName'
                                            label='Role Name'
                                            placeholder="Enter Role Name"
                                            type="text"
                                            onValueChange={(e) => handleChange(e.target.value)}
                                            value={addRoleData?.roleName}
                                        />
                                    </Box>
                                </Box>
                                {addRoleData?.type === false && <Box sx={{ gridColumn: 'span 6' }}>
                                    <Box >
                                        <DatePickerInput
                                            errors={errors}
                                            control={control}
                                            name='expireDate'
                                            label={'Expire Date'}
                                            register={register}
                                            type="text"
                                            value={addRoleData?.expiryDate}
                                            onValueChange={(e) => handleDateChange(e)}
                                        />
                                    </Box>
                                </Box>}
                                <Box sx={{ gridColumn: 'span 6' }}>
                                    <div className='flex flex-col'>
                                        <label>Status</label>
                                        <div className='flex flex-row items-center pt-[10px]'>
                                            <ToggleSwitch isChecked={addRoleData?.isActive} onChange={(value) => handleActiveChange(value)} />
                                            <p className='pl-[10px]'>{!addRoleData?.isActive ? 'In Active' : 'Active'}</p>
                                        </div>
                                    </div>
                                </Box>
                            </Box>
                        </div>
                    </div>
                    <div className={cn('py-4 bg-card flex flex-row items-center justify-end static pr-[20px] w-[100%]')}>
                        <Button variant='outline' style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }} onClick={handleCancel}>Cancel</Button>
                        <Button className='ml-3' onClick={() => handleSubmit(onSubmit)()} disabled={isLoading || isSubmitting}>{'Save'}</Button>
                    </div>
                </div>
            </SwipeableDrawer>
        </div>
    )
}

export default RolesAnaPermissionsContainer
